import { html, css, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import type { ModalAttributes } from 'zaptic-modal'
import { positiveIntegerAttributeSchema } from './helpers/yup'

const convertZIndexAttributeToProperty = (newValue: string) => {
    try {
        return positiveIntegerAttributeSchema.validateSync(newValue)
    } catch (ignore) {
        return null
    }
}

@customElement('zaptic-modal')
export class Modal extends LitElement implements ModalAttributes {
    static styles = css`
        :host {
            position: relative;
        }

        .back-drop {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100vh;
            width: 100vw;
            background-color: var(--Modal-backgroundColor);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `

    @property({
        type: Number,
        converter: convertZIndexAttributeToProperty,
    })
    'z-index' = 2

    render() {
        const zIndex = this['z-index']
        return html`
            <div class="back-drop" style="z-index: ${zIndex};">
                <slot></slot>
            </div>
        `
    }
}
